import { cx } from '@linaria/core';
import type { ImageProps } from 'next/image';
import Image from 'next/image';
import type { ReactEventHandler } from 'react';

import { emptyPlaceholder } from '~constants/images';
import { MediaTypes, type TMedia } from '~constants/media';
import {
	buildFullUrl,
	getSrcString,
	onImageLoadError,
	pickImageByType,
} from '~utils/images';

import { blurredImage, image } from './styles';

export interface FadeInImageProps extends Omit<ImageProps, 'src'> {
	src?: ImageProps['src'];
	media?: TMedia[];
	fallback?: string;
	preview?: boolean;
	blurred?: boolean;
}

const handleLoad: ReactEventHandler<HTMLImageElement> = (e) => {
	(e.target as HTMLImageElement).classList.remove('h');
};

export const FadeInImage = ({
	className,
	src: srcProp,
	loader: loaderProp,
	media,
	fallback,
	preview,
	blurred,
	alt,
	width,
	height,
	onLoad,
	...props
}: FadeInImageProps) => {
	const {
		src = emptyPlaceholder,
		loader = loaderProp,
		type,
	} = media
		? pickImageByType(media, { width, height }, fallback, preview)
		: { src: srcProp || (fallback && buildFullUrl(fallback)) };
	const key = getSrcString(src);

	return (
		<Image
			key={key}
			className={cx(
				className,
				'image',
				'h',
				image,
				(blurred || (preview && type === MediaTypes.videoCf)) && blurredImage
			)}
			src={src}
			loader={loader}
			width={width}
			height={height}
			alt={alt}
			onError={onImageLoadError}
			{...props}
			onLoad={(e) => {
				onLoad?.(e);
				handleLoad(e);
			}}
		/>
	);
};
